import React from "react";
import "./SupportContactPage.css";

const SupportContactPage = () => {
  return (
    <div className="support-contact-page">
      <header className="support-header">
        <h1>Support & Contact</h1>
        <p>Need help or have questions? We’re here to assist you anytime.</p>
      </header>

      <section className="support-section">
        <h2>24/7 Customer Support</h2>
        <p>
          Our dedicated support team is available around the clock to assist with any questions about your CRM, mobile app, or Chrome extension. Whether you’re facing technical issues or need help getting started, we’re just a message away.
        </p>
        <p>Email us at <a href="mailto:support@wspoints.com">support@wspoints.com</a> or use the contact form below.</p>
      </section>

      <section className="contact-form-section">
        <h2>Contact Us</h2>
        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <footer className="support-footer">
        <p>&copy; 2025 CRM Panel. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default SupportContactPage;